import { render, staticRenderFns } from "./default-main.vue?vue&type=template&id=ea418e8c&scoped=true"
import script from "./default-main.vue?vue&type=script&lang=js"
export * from "./default-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea418e8c",
  null
  
)

export default component.exports